export const MODIFIER_REGEX = /^[A-Za-z0-9]{2}$/;
